import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-letter-i', 'CircleLetterI', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M12 8v8"}]]);